import React, { useState, useEffect, useRef } from "react";
import { Table, Form, Button } from "react-bootstrap";
import ExportExcel from "../../utility/ExportCSV";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/authFetch";

function TestWiseReportTable({
  fromDate,
  toDate,
  setLoader,
  setButtonClicked,
}) {
  const [entries, setEntries] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (fromDate === "" || toDate === "") return;
    if (!setButtonClicked) return;
    authFetch(
      `${API_BASE_URL}/api/test-wise-report?fromDate=${fromDate}&toDate=${toDate}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          alert("Error fetching data");
          setButtonClicked(false);
          setLoader(false);
          return;
        }
        setEntries(data.report);
        setButtonClicked(false);
        setLoader(false);
      })
      .catch((err) => {
        console.error("Error fetching entries:", err);
        setButtonClicked(false);
        setLoader(false);
        return;
      });
  }, [fromDate, toDate]);

  const totalAmount = entries.reduce(
    (sum, item) => sum + (Number(item.amount) || 0),
    0
  );

  const totalCash = entries.reduce(
    (sum, item) =>
      sum + ((item.paymentMode === "Cash" ? Number(item.amount) : 0) || 0),
    0
  );

  const totalOnline = entries.reduce(
    (sum, item) =>
      sum + ((item.paymentMode !== "Cash" ? Number(item.amount) : 0) || 0),
    0
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <ExportExcel
          tableId="test-wise-report-table"
          filename={`$test-report-${fromDate}-to-${toDate}.csv`}
        />
      </div>
      <Table striped bordered hover id="test-wise-report-table" ref={tableRef}>
        <thead>
          <tr>
            <th>SL NO.</th>
            <th>TEST NAME</th>
            <th>COUNT</th>
            <th>AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {entries.length > 0 ? (
            <>
              {entries.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.testName}</td>
                  <td>{item.count}</td>
                  <td>{item.amount}</td>
                </tr>
              ))}

              {/* ✅ Total Row */}
              <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
                <td colSpan="3" className="text-end">
                  TOTAL:
                </td>
                <td>{totalAmount}</td>
              </tr>

              <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
                <td colSpan="3" className="text-end">
                  TOTAL CASH:
                </td>
                <td>{totalCash}</td>
              </tr>

              <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
                <td colSpan="3" className="text-end">
                  TOTAL ONLINE:
                </td>
                <td>{totalOnline}</td>
              </tr>
            </>
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No Entries
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export default TestWiseReportTable;
